import React, { useState, useEffect } from 'react';
import { Container, Grid, Paper, Typography, Button, Tabs, Tab, Box } from '@mui/material';
import Navigation from '../components/Navbar';
import Footer from '../components/Footer';
import './Packages.css';
import heroImage from '../assets/images/Logo.png';

// Data Objects
const countryPlans = {
  india: {
    registration: [
      {
        title: "Private Limited Company",
        startsFrom: true,
        originalPrice: "₹18,749",
        discountedPrice: "₹14,999",
        savings: "20% OFF",
        features: [
          "DIN & DSC for 2 Directors",
          "Company Name Approval",
          "MOA & AOA Drafting",
          "PAN & TAN Registration",
          "GST Registration",
          "Incorporation Certificate",
          "Bank Account Opening Support",
          "Compliance Calendar"
        ]
      },
      {
        title: "LLP Registration",
        startsFrom: true,
        originalPrice: "₹14,999",
        discountedPrice: "₹11,999",
        savings: "20% OFF",
        features: [
          "2 Designated Partners DSC",
          "LLP Name Approval",
          "LLP Agreement Drafting",
          "PAN & TAN Registration",
          "GST Registration",
          "Incorporation Certificate",
          "Bank Account Opening Support",
          "Annual Compliance Guidance"
        ]
      },
      {
        title: "One Person Company",
        startsFrom: true,
        originalPrice: "₹16,249",
        discountedPrice: "₹12,999",
        savings: "20% OFF",
        features: [
          "DIN & DSC for Director",
          "Company Name Approval",
          "MOA & AOA Drafting",
          "PAN & TAN Registration",
          "GST Registration",
          "Incorporation Certificate",
          "Bank Account Opening Support",
          "Compliance Management"
        ]
      },
      {
        title: "Startup India Registration",
        startsFrom: true,
        originalPrice: "₹9,999",
        discountedPrice: "₹7,999",
        savings: "20% OFF",
        features: [
          "Startup Recognition Application",
          "DIPP Number Generation",
          "Tax Exemption Support",
          "IPR Fast-tracking",
          "Government Tender Benefits",
          "Self-Certification Compliance",
          "Startup India Certificate",
          "Investor Connect Support"
        ]
      }
    ],
    website: [
      {
        title: "BASIC",
        startsFrom: true,
        originalPrice: "₹18,749",
        discountedPrice: "₹14,999",
        savings: "20% OFF",
        features: [
          "5 Pages Professional Website",
          "Mobile Responsive Design",
          "Basic SEO Setup",
          "Contact/Enquiry Form",
          "1 Month Free Support",
          "Free Domain for 1 Year*",
          "Basic Branding Guidelines"
        ]
      },
      {
        title: "STANDARD",
        startsFrom: true,
        originalPrice: "₹31,249",
        discountedPrice: "₹24,999",
        savings: "20% OFF",
        features: [
          "10-15 Pages Website",
          "Advanced UI/UX Design",
          "Intermediate SEO Setup",
          "Contact Form + Newsletter",
          "3 Months Free Support",
          "Free Domain for 1 Year*",
          "Social Media Integration",
          "Basic Analytics Setup"
        ]
      },
      {
        title: "PREMIUM",
        startsFrom: true,
        originalPrice: "₹62,499",
        discountedPrice: "₹49,999",
        savings: "20% OFF",
        features: [
          "25-30 Pages Website",
          "Premium UI/UX Design",
          "Advanced SEO Setup",
          "Custom CMS Integration",
          "6 Months Free Support",
          "Free Domain & Hosting for 1 Year",
          "Complete Branding Package",
          "Logo Design Included",
          "E-commerce Functionality"
        ]
      },
      {
        title: "ENTERPRISE",
        startsFrom: true,
        originalPrice: "₹112,499",
        discountedPrice: "₹89,999",
        savings: "20% OFF",
        features: [
          "Unlimited Pages Website",
          "Multi-user Login System",
          "Custom Dashboards",
          "Advanced SEO Strategy",
          "1 Year Free Support",
          "Free Domain & Hosting for 1 Year",
          "Premium Branding Package",
          "Logo Design + Stationery Kit",
          "Priority Support",
          "API Integrations"
        ]
      }
    ]
  },
  usa: {
    registration: [
      {
        title: "LLC Formation",
        startsFrom: true,
        originalPrice: "$624",
        discountedPrice: "$499",
        savings: "20% OFF",
        features: [
          "Business Name Availability Check",
          "Articles of Organization",
          "EIN Registration",
          "Operating Agreement",
          "State Filing Fees Included",
          "Registered Agent Service (1st Year)",
          "Business Banking Support",
          "Compliance Alerts"
        ]
      },
      {
        title: "C-Corp Formation",
        startsFrom: true,
        originalPrice: "$999",
        discountedPrice: "$799",
        savings: "20% OFF",
        features: [
          "Business Name Reservation",
          "Articles of Incorporation",
          "EIN Registration",
          "Corporate Bylaws Drafting",
          "State Filing Fees Included",
          "Registered Agent Service (1st Year)",
          "Initial Board Meeting Minutes",
          "Stock Issuance Support"
        ]
      },
      {
        title: "S-Corp Election",
        startsFrom: true,
        originalPrice: "$374",
        discountedPrice: "$299",
        savings: "20% OFF",
        features: [
          "S-Corp Tax Election Filing",
          "Form 2553 Preparation",
          "IRS Submission",
          "Tax Savings Consultation",
          "Payroll Setup Guidance",
          "Shareholder Agreement Review",
          "Annual Compliance Checklist"
        ]
      },
      {
        title: "Nonprofit Registration",
        startsFrom: true,
        originalPrice: "$1,874",
        discountedPrice: "$1,499",
        savings: "20% OFF",
        features: [
          "501(c)(3) Application",
          "Articles of Incorporation",
          "Bylaws Drafting",
          "EIN Registration",
          "State Charity Registration",
          "Tax Exemption Guidance",
          "Fundraising Compliance",
          "Board Meeting Templates"
        ]
      }
    ],
    website: [
      {
        title: "BASIC",
        startsFrom: true,
        originalPrice: "$374",
        discountedPrice: "$299",
        savings: "20% OFF",
        features: [
          "5 Pages Professional Website",
          "Mobile Responsive Design",
          "Basic SEO Setup",
          "Contact/Enquiry Form",
          "1 Month Free Support",
          "Free Domain for 1 Year*",
          "Basic Branding Guidelines"
        ]
      },
      {
        title: "STANDARD",
        startsFrom: true,
        originalPrice: "$624",
        discountedPrice: "$499",
        savings: "20% OFF",
        features: [
          "10-15 Pages Website",
          "Advanced UI/UX Design",
          "Intermediate SEO Setup",
          "Contact Form + Newsletter",
          "3 Months Free Support",
          "Free Domain for 1 Year*",
          "Social Media Integration",
          "Basic Analytics Setup"
        ]
      },
      {
        title: "PREMIUM",
        startsFrom: true,
        originalPrice: "$1,249",
        discountedPrice: "$999",
        savings: "20% OFF",
        features: [
          "25-30 Pages Website",
          "Premium UI/UX Design",
          "Advanced SEO Setup",
          "Custom CMS Integration",
          "6 Months Free Support",
          "Free Domain & Hosting for 1 Year",
          "Complete Branding Package",
          "Logo Design Included",
          "E-commerce Functionality"
        ]
      },
      {
        title: "ENTERPRISE",
        startsFrom: true,
        originalPrice: "$2,499",
        discountedPrice: "$1,999",
        savings: "20% OFF",
        features: [
          "Unlimited Pages Website",
          "Multi-user Login System",
          "Custom Dashboards",
          "Advanced SEO Strategy",
          "1 Year Free Support",
          "Free Domain & Hosting for 1 Year",
          "Premium Branding Package",
          "Logo Design + Stationery Kit",
          "Priority Support",
          "API Integrations"
        ]
      }
    ]
  }
};

const additionalServices = {
  india: [
    {
      title: "MSME Certification",
      description: "Udyam Registration for Micro, Small & Medium Enterprises",
      startsFrom: true,
      originalPrice: "₹3,749",
      discountedPrice: "₹2,999",
      savings: "20% OFF"
    },
    {
      title: "Trademark Registration",
      description: "Protect your brand with trademark registration",
      startsFrom: true,
      originalPrice: "₹8,749",
      discountedPrice: "₹6,999",
      savings: "20% OFF"
    },
    {
      title: "GST Registration",
      description: "Complete GST registration and compliance",
      startsFrom: true,
      originalPrice: "₹3,124",
      discountedPrice: "₹2,499",
      savings: "20% OFF"
    },
    {
      title: "Import Export Code",
      description: "IEC registration for international trade",
      startsFrom: true,
      originalPrice: "₹2,499",
      discountedPrice: "₹1,999",
      savings: "20% OFF"
    },
    {
      title: "Logo + Branding Package",
      description: "Professional logo with complete branding",
      startsFrom: true,
      originalPrice: "₹15,624",
      discountedPrice: "₹12,499",
      savings: "20% OFF"
    },
    {
      title: "FSSAI Registration",
      description: "Food license for food businesses",
      startsFrom: true,
      originalPrice: "₹4,999",
      discountedPrice: "₹3,999",
      savings: "20% OFF"
    }
  ],
  usa: [
    {
      title: "Trademark Registration",
      description: "Federal trademark registration",
      startsFrom: true,
      originalPrice: "$624",
      discountedPrice: "$499",
      savings: "20% OFF"
    },
    {
      title: "EIN Registration",
      description: "Employer Identification Number",
      startsFrom: true,
      originalPrice: "$187",
      discountedPrice: "$149",
      savings: "20% OFF"
    },
    {
      title: "DBA Registration",
      description: "Doing Business As registration",
      startsFrom: true,
      originalPrice: "$249",
      discountedPrice: "$199",
      savings: "20% OFF"
    },
    {
      title: "Sales Tax Permit",
      description: "State sales tax registration",
      startsFrom: true,
      originalPrice: "$249",
      discountedPrice: "$199",
      savings: "20% OFF"
    },
    {
      title: "Logo + Branding Package",
      description: "Professional logo with complete branding",
      startsFrom: true,
      originalPrice: "$624",
      discountedPrice: "$499",
      savings: "20% OFF"
    },
    {
      title: "Business License",
      description: "Local business license registration",
      startsFrom: true,
      originalPrice: "$374",
      discountedPrice: "$299",
      savings: "20% OFF"
    }
  ]
};

// TabPanel Component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

// Main Component
const Packages = () => {
  const [country, setCountry] = useState('india');
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    setCountry(newValue === 0 ? 'india' : 'usa');
  };

  return (
    <>
      <Navigation />
      <Container className="pkg-container">
        {/* Page Header */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h3" className="pkg-header">
            Complete Startup Solutions
          </Typography>
          <Typography variant="body1" className="pkg-header-description" sx={{ mx: 'auto' }}>
            Everything you need to launch and grow your business
          </Typography>
        </Box>

        {/* Image Below Header */}
        <Box sx={{ textAlign: 'center', my: 4 }}>
          <img src={heroImage} alt="Startup Solutions" className="pkg-header-image" />
        </Box>

        {/* Country Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', margin: '40px 0' }}>
          <Tabs 
            value={tabValue} 
            onChange={handleChange} 
            centered
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="India Service Packages (INR)" />
            <Tab label="USA Service Packages (USD)" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          {/* Business Registration Packages - India */}
          <Box className="pkg-section">
            <Box className="pkg-section-header" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography variant="h3" className="pkg-section-title">
                Business Registration Packages
              </Typography>
              <Typography variant="body1" className="pkg-section-description">
                Complete legal registration and compliance solutions for Indian businesses
              </Typography>
            </Box>
            
            <Grid container spacing={4} className="pkg-grid">
              {countryPlans.india.registration.map((plan, index) => (
                <Grid item xs={12} md={6} lg={3} key={index}>
                  <Paper className="pkg-card" elevation={3}>
                    <Typography variant="h5" className="pkg-card-title">{plan.title}</Typography>
                    <div className="pkg-price-container">
                      <Typography className="pkg-price-starts">Starts from</Typography>
                      <Typography className="pkg-original-price">
                        <s>{plan.originalPrice}</s>
                      </Typography>
                      <Typography className="pkg-discounted-price">
                        {plan.discountedPrice}
                      </Typography>
                      <Typography className="pkg-savings-badge">
                        {plan.savings}
                      </Typography>
                    </div>
                    <div className="pkg-features-container">
                      <ul className="pkg-features-list">
                        {plan.features.map((feature, fIndex) => (
                          <li key={fIndex} className="pkg-feature-item">{feature}</li>
                        ))}
                      </ul>
                    </div>
                    <Button variant="contained" className="pkg-card-button" fullWidth>
                      Get Started
                    </Button>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Website Development Packages - India */}
          <Box className="pkg-section">
            <Box className="pkg-section-header" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography variant="h3" className="pkg-section-title">
                Website Development Packages
              </Typography>
              <Typography variant="body1" className="pkg-section-description">
                Professional website solutions tailored for your business needs
              </Typography>
            </Box>
            
            <Grid container spacing={4} className="pkg-grid">
              {countryPlans.india.website.map((plan, index) => (
                <Grid item xs={12} md={6} lg={3} key={index}>
                  <Paper className="pkg-card" elevation={3}>
                    <Typography variant="h5" className="pkg-card-title">{plan.title}</Typography>
                    <div className="pkg-price-container">
                      <Typography className="pkg-price-starts">Starts from</Typography>
                      <Typography className="pkg-original-price">
                        <s>{plan.originalPrice}</s>
                      </Typography>
                      <Typography className="pkg-discounted-price">
                        {plan.discountedPrice}
                      </Typography>
                      <Typography className="pkg-savings-badge">
                        {plan.savings}
                      </Typography>
                    </div>
                    <div className="pkg-features-container">
                      <ul className="pkg-features-list">
                        {plan.features.map((feature, fIndex) => (
                          <li key={fIndex} className="pkg-feature-item">{feature}</li>
                        ))}
                      </ul>
                    </div>
                    <Button variant="contained" className="pkg-card-button" fullWidth>
                      Get Started
                    </Button>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Additional Services - India */}
          <Box className="pkg-section">
            <Box className="pkg-section-header" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography variant="h3" className="pkg-section-title">
                Additional Services
              </Typography>
              <Typography variant="body1" className="pkg-section-description">
                Complementary services to complete your business setup
              </Typography>
            </Box>
            
            <Grid container spacing={4} className="pkg-services-grid">
              {additionalServices.india.map((service, index) => (
                <Grid item xs={12} md={6} lg={4} key={index}>
                  <Paper className="pkg-service-card" elevation={3}>
                    <Typography variant="h5" className="pkg-service-title">{service.title}</Typography>
                    <Typography variant="body1" className="pkg-service-description" sx={{ textAlign: 'center' }}>
                      {service.description}
                    </Typography>
                    <div className="pkg-price-container">
                      <Typography className="pkg-price-starts">Starts from</Typography>
                      <Typography className="pkg-original-price">
                        <s>{service.originalPrice}</s>
                      </Typography>
                      <Typography className="pkg-discounted-price">
                        {service.discountedPrice}
                      </Typography>
                      <Typography className="pkg-savings-badge">
                        {service.savings}
                      </Typography>
                    </div>
                    <Button variant="outlined" className="pkg-service-button" fullWidth>
                      Add to Package
                    </Button>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          {/* Business Registration Packages - USA */}
          <Box className="pkg-section">
            <Box className="pkg-section-header" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography variant="h3" className="pkg-section-title">
                Business Registration Packages
              </Typography>
              <Typography variant="body1" className="pkg-section-description">
                Complete legal registration and compliance solutions for US businesses
              </Typography>
            </Box>
            
            <Grid container spacing={4} className="pkg-grid">
              {countryPlans.usa.registration.map((plan, index) => (
                <Grid item xs={12} md={6} lg={3} key={index}>
                  <Paper className="pkg-card" elevation={3}>
                    <Typography variant="h5" className="pkg-card-title">{plan.title}</Typography>
                    <div className="pkg-price-container">
                      <Typography className="pkg-price-starts">Starts from</Typography>
                      <Typography className="pkg-original-price">
                        <s>{plan.originalPrice}</s>
                      </Typography>
                      <Typography className="pkg-discounted-price">
                        {plan.discountedPrice}
                      </Typography>
                      <Typography className="pkg-savings-badge">
                        {plan.savings}
                      </Typography>
                    </div>
                    <div className="pkg-features-container">
                      <ul className="pkg-features-list">
                        {plan.features.map((feature, fIndex) => (
                          <li key={fIndex} className="pkg-feature-item">{feature}</li>
                        ))}
                      </ul>
                    </div>
                    <Button variant="contained" className="pkg-card-button" fullWidth>
                      Get Started
                    </Button>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Website Development Packages - USA */}
          <Box className="pkg-section">
            <Box className="pkg-section-header" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography variant="h3" className="pkg-section-title">
                Website Development Packages
              </Typography>
              <Typography variant="body1" className="pkg-section-description">
                Professional website solutions tailored for your business needs
              </Typography>
            </Box>
            
            <Grid container spacing={4} className="pkg-grid">
              {countryPlans.usa.website.map((plan, index) => (
                <Grid item xs={12} md={6} lg={3} key={index}>
                  <Paper className="pkg-card" elevation={3}>
                    <Typography variant="h5" className="pkg-card-title">{plan.title}</Typography>
                    <div className="pkg-price-container">
                      <Typography className="pkg-price-starts">Starts from</Typography>
                      <Typography className="pkg-original-price">
                        <s>{plan.originalPrice}</s>
                      </Typography>
                      <Typography className="pkg-discounted-price">
                        {plan.discountedPrice}
                      </Typography>
                      <Typography className="pkg-savings-badge">
                        {plan.savings}
                      </Typography>
                    </div>
                    <div className="pkg-features-container">
                      <ul className="pkg-features-list">
                        {plan.features.map((feature, fIndex) => (
                          <li key={fIndex} className="pkg-feature-item">{feature}</li>
                        ))}
                      </ul>
                    </div>
                    <Button variant="contained" className="pkg-card-button" fullWidth>
                      Get Started
                    </Button>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Additional Services - USA */}
          <Box className="pkg-section">
            <Box className="pkg-section-header" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography variant="h3" className="pkg-section-title">
                Additional Services
              </Typography>
              <Typography variant="body1" className="pkg-section-description">
                Complementary services to complete your business setup
              </Typography>
            </Box>
            
            <Grid container spacing={4} className="pkg-services-grid">
              {additionalServices.usa.map((service, index) => (
                <Grid item xs={12} md={6} lg={4} key={index}>
                  <Paper className="pkg-service-card" elevation={3}>
                    <Typography variant="h5" className="pkg-service-title">{service.title}</Typography>
                    <Typography variant="body1" className="pkg-service-description" sx={{ textAlign: 'center' }}>
                      {service.description}
                    </Typography>
                    <div className="pkg-price-container">
                      <Typography className="pkg-price-starts">Starts from</Typography>
                      <Typography className="pkg-original-price">
                        <s>{service.originalPrice}</s>
                      </Typography>
                      <Typography className="pkg-discounted-price">
                        {service.discountedPrice}
                      </Typography>
                      <Typography className="pkg-savings-badge">
                        {service.savings}
                      </Typography>
                    </div>
                    <Button variant="outlined" className="pkg-service-button" fullWidth>
                      Add to Package
                    </Button>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </TabPanel>

        {/* CTA Section */}
        <Box className="pkg-cta-section" sx={{ textAlign: 'center' }}>
          <Typography variant="h4" className="pkg-cta-title">
            Ready to launch your business?
          </Typography>
          <Typography variant="body1" className="pkg-cta-description" sx={{ mx: 'auto' }}>
            Contact us for custom packages and special discounts
          </Typography>
          <Button variant="contained" className="pkg-cta-button" size="large">
            Get a Free Consultation
          </Button>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default Packages;